import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const totalEarningApi = createApi({
    reducerPath: "totalEarningApi",
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem("token");
            if (token) {
                headers.set("authorization", `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({ 
        getConsignedProfitByDate: builder.mutation({
            query: ({ fromDate, toDate }) => ({
                url: `/Dashboard/profit-of-consigned/${fromDate}/${toDate}`,
                method: "GET",
            }),
            invalidatesTags: ["TotalEarnings"],
        }),
 
        getOtherProfitByDate: builder.mutation({
            query: ({ fromDate, toDate }) => ({
                url: `/Dashboard/profit-of-other/${fromDate}/${toDate}`,
                method: "GET",
            }),
            invalidatesTags: ["TotalEarnings"],
        }),
 
        getAllConsignedProfit: builder.query({
            query: () => `/Dashboard/profit-of-consigned`,
            providesTags: ["TotalEarnings"],
        }),
 
        getAllOtherProfit: builder.query({
            query: () => ({
                url: `/Dashboard/profit-of-other`,
                method: "GET",
            }),
            providesTags: ["TotalEarnings"],
        }),

        getServiceProfitByDate: builder.mutation({
            query: ({ fromDate, toDate }) => ({
                url: `/Dashboard/profit-of-service/${fromDate}/${toDate}`,
                method: "GET",
            }),
            invalidatesTags: ["TotalEarnings"],
        }),

        getAllServiceProfit: builder.query({
            query: () => `/Dashboard/profit-of-service`,
            providesTags: ["TotalEarnings"],
        }),
    }),
});

export const {
    useGetConsignedProfitByDateMutation,
    useGetOtherProfitByDateMutation,
    useGetAllConsignedProfitQuery,
    useGetAllOtherProfitQuery,
    useGetAllServiceProfitQuery,
    useGetServiceProfitByDateMutation,
} = totalEarningApi;
